export const CommanderHandlersList = {
  MovingAverageCrossover: {
    text: 'Moving Average Crossover',
    id: '826ab7a8-b903-4bf2-a475-35d3ca9f5e6e'
  }
};
